import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

interface Permission {
  accessType: number,
  isDeleted: number,
  name: string,
  permissionId: number,
  productId: number,
  slug: string
}
@Injectable({
  providedIn: 'root'
})


export class AuthGuard implements CanActivate {
  constructor(private router: Router) { };
  permissions: Permission[] = []
  navigateUser = true;
  navData: any;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('accessToken')
    const permissions = localStorage.getItem('permissions')
    this.permissions = permissions ? JSON.parse(permissions) : [];
    this.navData = next.data;

    const isAdmin = localStorage.getItem('isAdmin');
    console.log("TOKEN------------>", token)
    console.log(next.data);

    if (token) {
      return this.navigateUser;
    }
    else {
      if (state.url.includes('impersonate')) {
        return true;
      }
      this.router.navigate(['/login']);
      return false
    }
  }

  hasPermission(slug: string) {
    const permission = (this.permissions || []).find((x: Permission) => x.slug === slug);
    var pageRedirect = false
    if (permission && permission.accessType > 0) {
      pageRedirect = true
    } else {
      alert(`restricted access to ${slug} || Allowed for now`)
      // this.router.navigate(['/qaasar/chat'])
      pageRedirect = true
    }
    return pageRedirect
  }


}
